const LabelMapper = {
  total: 'Total amount awarded',
  competitive: 'Competitive grants',
  demandDriven: 'Demand driven grants',
  electionCommitments: 'Election Commitments',
  otherGrants: 'Other grants',
  totalCompetitive: 'Total amount',
  totalDemandDriven: 'Total amount',
  totalElectionCommitments: 'Total amount',
  totalOther: 'Total amount',
  awardedCompetitive: 'Number of grants',
  awardedDemandDriven: 'Number of grants',
  electionCommitmentsNumber: 'Number of grants',
  awardedOther: 'Number of grants',
  perPerson: 'Sport grants awarded per person',
  perSport: 'Sport grants awarded by type of sport',
  afl: 'AFL',
  multisport: 'Multisport or active recreation',
  football: 'Football (soccer)',
  netball: 'Netball',
  rugby: 'Rugby League',
  cricket: 'Cricket',
  basketball: 'Basketball',
  hockey: 'Hockey',
  golf: 'Golf',
  rugbyUnion: 'Rugby Union',
  other: 'Other',
};
const labelMatcher = str => {
  const label = LabelMapper[str];
  if (!label) {
    throw Error('Missing label for: ' + str);
  }
  return label;
};
export default labelMatcher;



// WEBPACK FOOTER //
// ./src/helpers/label-mapper.js